import Dexie, { type Table } from 'dexie';
import type { CachedManifest } from '@/types';

// IndexedDB schemas. We hold the manifest, a write queue for offline replay,
// and a thumbnail cache (raw bytes — the SW caches HTTP responses, this
// caches the decoded blob URLs we hand to <img>).

export interface QueuedWrite {
  idempotency_key: string;
  endpoint: string;          // e.g. "/pins"
  method: 'POST' | 'PATCH' | 'DELETE';
  body: unknown;
  created_at: number;
  attempts: number;
  last_error?: string;
}

class MemoryMapDB extends Dexie {
  manifest!: Table<{ id: 'singleton' } & CachedManifest, 'singleton'>;
  writes!:   Table<QueuedWrite, string>;

  constructor() {
    super('memorymap');
    this.version(1).stores({
      manifest: 'id',
      writes:   'idempotency_key, created_at',
    });
  }
}

export const db = new MemoryMapDB();

export async function readCachedManifest(): Promise<CachedManifest | null> {
  const row = await db.manifest.get('singleton');
  if (!row) return null;
  const { id, ...rest } = row;
  void id;
  return rest;
}

export async function writeCachedManifest(m: CachedManifest): Promise<void> {
  await db.manifest.put({ id: 'singleton', ...m });
}
